import * as React from 'react'
import { Helmet } from 'react-helmet'
import * as styles from '../assets/styles.module.scss'
import Logo from '../assets/vectors/logo.svg'

export default class Header extends React.Component<{}, {}> {
    render() {
        return (
            <>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Presets For Every Purpose | Alfredo Juárez</title>
                    <link rel="canonical" href="https://shop.alfrek.net/" />
                </Helmet>
                
                <header className={styles.Header}>
                    <div className={styles.Centered}>
                        <a href={`/`}><Logo /></a>
                    </div>
                </header>
            </>
        )
    }
}